import compose from "recompose/compose";
import withState from "recompose/withState";
import withHandlers from "recompose/withHandlers";

const withProductAddedPopIn = () =>
  compose(
    withState("productAdded", "setProductAdded", false),
    withHandlers({
      showPopin: (props) => (product) => props.setProductAdded(product),
      hidePopin: (props) => () => props.setProductAdded(null),
    })
  );

export default withProductAddedPopIn;
